import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { apiGetPage } from '../../request/api';
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';

interface ServiceItem {
  serviceName: string;
  description: string;
  fee: string;
}

interface ServiceTabsProps {
  onOpenModal?: (data: any) => void; // 修改类型
  onOpenNote?: (type: 'basic' | 'premium') => void;
  loading?: boolean;
  packageList?: any[];
  groupedData?: Record<string, ServiceItem[]>; // 添加正确的类型
}

const ServiceTabs: React.FC<ServiceTabsProps> = ({ onOpenModal, onOpenNote, loading, packageList, groupedData = {} }) => {
  const themeColor = useSelector((state: RootState) => state.themeColor.value);
  const [hoveredService, setHoveredService] = useState<string | null>(null);
  const { getValue } = useCustomData();
  const iwant = getValue('iwant');

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>Loading services...</div>;
  }

  return (
    <div className="service-tabs" style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Tabs
        tabPosition="top"
        tabBarStyle={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start'
        }}
        items={Object.keys(groupedData).map(category => ({
          label: (
            <div className="custom-tab-label">
              <span style={{
                fontSize: '24px',
                fontWeight: 400,
                color: '#33364b',
                letterSpacing: '0.9px'
              }}>
                {category}
              </span>
            </div>
          ),
          key: category,
          children: (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: 24,
              padding: 24
            }}>
              {groupedData[category]?.map(service => ( // 使用可选链操作符
                <div
                  key={service.serviceName}
                  className="service-card"
                  onMouseEnter={() => setHoveredService(service.serviceName)}
                  onMouseLeave={() => setHoveredService(null)}
                >
                  <div className="card-content">
                    <h3 style={{
                      color: hoveredService === service.serviceName ? themeColor : '#33364b',
                      transition: 'color 0.3s'
                    }}>
                      {service.serviceName}
                    </h3>
                    <p className="description">{service.description}</p>
                    <div className="fee-section">
                      <span>{service.fee}</span>
                      <div
                        className="action-button"
                        style={{
                          color: themeColor,
                          opacity: hoveredService === service.serviceName ? 1 : 0,
                          transition: 'opacity 0.3s',
                          pointerEvents: hoveredService === service.serviceName ? 'auto' : 'none'
                        }}
                        onClick={() => {
                          // 找到对应套餐对象
                          const matchedPlan = packageList?.find((p: { commodityName: string }) => p.commodityName === service.serviceName);
                          if (matchedPlan) onOpenModal?.(matchedPlan);
                        }}
                      >
                        {iwant}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        }))}
      />
    </div>
  );
};

export default ServiceTabs;